import { computed } from 'vue'

import { useServicesDeFiStore } from '@/stores/services-defi'
import { useUserStore } from '@/stores/user'

import type { ServicesNotificationType } from '../ServicesNotification/types'

export function useServicesNotification() {
  const servicesDeFiStore = useServicesDeFiStore()
  const userStore = useUserStore()

  const added = computed(() =>
    servicesDeFiStore.groupedUpdatedServices.filter(
      (group) => !group.disabled_date
    )
  )
  const removed = computed(() =>
    servicesDeFiStore.groupedUpdatedServices.filter(
      (group) => group.disabled_date
    )
  )
  const type = computed<ServicesNotificationType>(() => {
    if (!userStore.settings.last_seen_new_defi_services) {
      return 'init'
    }
    if (added.value.length && removed.value.length) {
      return 'both'
    }
    if (added.value.length) {
      return 'added'
    }
    return 'removed'
  })

  async function prepare(): Promise<boolean> {
    const { user } = userStore
    if (!user) {
      return false
    }

    await servicesDeFiStore.checkUpdatedServices(user.id)
    return servicesDeFiStore.groupedUpdatedServices.length > 0
  }

  return { prepare, added, removed, type }
}
